export default __webpack_public_path__ + "b4043e4e54e2eec5524fcf1b0101ccf9.png";